
<template>
  <div class="quiz-dark-wrapper">
    <main-header />
    <ProgressBar is-dark />
    <slot />
  </div>
</template>

<script lang="ts" setup>
import ProgressBar from '@/components/quiz/ProgressBar.vue';

const { $versions } = useNuxtApp();

const isQuizV4 = computed((): boolean => {
  return $versions.value.quiz === '4';
});
</script>

<style lang="scss" scoped>
.quiz-dark-wrapper {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background: $light-pink;
}
</style>
